module.exports = __webpack_public_path__ + "img/icon_update.d8fabb2f.svg";